import React, { useMemo, useState } from 'react';
import { getRowsColumns, getValue, safeLower } from './shared';

function toCsv(rows, columns) {
  var header = columns.join(',');
  var body = rows.map(function (row) {
    return columns
      .map(function (column) {
        var cell = getValue(row, column).replace(/\"/g, '\"\"');
        return '"' + cell + '"';
      })
      .join(',');
  });

  return [header].concat(body).join('\n');
}

function downloadCsv(filename, csvText) {
  var blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
  var url = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export default function TableWidget({ rows, loading, error, widget }) {
  var [searchText, setSearchText] = useState('');

  var columns = useMemo(function () {
    return getRowsColumns(rows);
  }, [rows]);

  var filteredRows = useMemo(
    function () {
      if (!searchText) {
        return rows;
      }

      var needle = safeLower(searchText);
      return (rows || []).filter(function (row) {
        return columns.some(function (column) {
          return safeLower(getValue(row, column)).includes(needle);
        });
      });
    },
    [rows, columns, searchText]
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="re-widget-empty">{error}</div>;
  }

  return (
    <div className="re-table-widget">
      <div className="re-table-toolbar">
        <input
          value={searchText}
          placeholder="Search"
          onChange={function onChange(event) {
            setSearchText(event.target.value);
          }}
        />
        <button
          type="button"
          onClick={function onClick() {
            var csvText = toCsv(filteredRows || [], columns || []);
            var exportName = (widget.id || 'report-table') + '.csv';
            downloadCsv(exportName, csvText);
          }}
        >
          Export CSV
        </button>
      </div>

      <div className="re-table-scroll">
        <table>
          <thead>
            <tr>
              {columns.map(function (column) {
                return <th key={column}>{column}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {filteredRows.map(function (row, index) {
              return (
                <tr key={index}>
                  {columns.map(function (column) {
                    return <td key={column}>{getValue(row, column)}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
